import { SET_IS_SCROLLED } from './constants'

export function setIsScrolled(data) {
    return {
        type: SET_IS_SCROLLED,
        data,
    }
}
